import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEREQUESTS } from "../../../../utils/constants";
import { PRInterface } from "../../../../models/ProcurementModule/PurchaseRequest";
import PRService from "../../../../services/procurementService/PRService";

interface DeletePR {
  previousPR: PRInterface[];
  deletedPR: PRInterface | undefined;
}

const useDeletePR = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string, DeletePR>({
    mutationFn: PRService.Remove,

    onMutate: (dataId: string) => {
      const previousPR =
        queryClient.getQueryData<PRInterface[]>([
          CACHE_KEY_PURCHASEREQUESTS,
          page,
          pageSize,
        ]) || [];

      queryClient.setQueryData<PRInterface[]>(
        [CACHE_KEY_PURCHASEREQUESTS, page, pageSize],
        previousPR.filter((data) => data.id !== dataId)
      );

      return {
        previousPR,
        deletedPR: previousPR.find((data) => data.id === dataId),
      };
    },

    onError: (error, dataId, context) => {
      if (!context) return;

      queryClient.setQueryData<PRInterface[]>(
        [CACHE_KEY_PURCHASEREQUESTS, page, pageSize],
        context.previousPR
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeletePR;
